<script lang="ts">
  export let companyPrimaryColor: string;
  export let text: string;
  export let buttonText: string;
  export let toggleCardState: () => void;
</script>

<span class="text-sm text-[#475467] font-small">
  {text}
  <button
    type="button"
    class="hover:underline hover:cursor-pointer font-medium bg-transparent border-0 text-inherit inline p-0 m-0"
    style={`color: ${companyPrimaryColor || '#2E9990'}; display: inline;`}
    data-testid="switcher-button"
    on:click={() => {
      toggleCardState();
    }}>{buttonText}</button
  >
</span>

<div class="border-b border-[#EAECF0]" />
